import { provideObjClass } from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"
import { ScrivitoAttributes } from "shared/types/ScrivitoAttributes"

export const ProjectPageObjClass = provideObjClass("ProjectPage", {
  attributes: {
    ...defaultPageAttributes,
    data: "datalocator",
    chatWidgets: "widgetlist",

    enableChat: "boolean",
    chatButtonText: "string",
    hideChatWhenNoOpportunity: "boolean",

    isLoginRequired: "boolean"
  },
  extractTextAttributes: ["body"]
})
export type ProjectPageObj = InstanceType<typeof ProjectPageObjClass>
export type ProjectPageObjAttributes = ScrivitoAttributes<ProjectPageObj>
